import React, { useContext } from "react";
import { useNavigate } from "react-router";
import { RaffleRow, TimeCell, NameWithModel, NameDetails, RaffleType, PrizeCell, StatusCell, StatusIcon, StatusLabel } from "./RaffleList.styles";
import { LuCheck, LuClock } from "react-icons/lu";
import RaffleTypeModel from "./RaffleTypeModel";

import { DateTime } from "luxon";
import GetHotSeatName from "../util/GetHotSeatName";
import { SiteContext } from "../context/SiteContext";
import { getCurrencyConfig } from "./services";

export const getCurrencySymbol = (value, defaultSymbol = "S/") => {
  switch (value) {
    case 1:
      return defaultSymbol;
    case 2:
      return "$";
    case 3:
      return "€";
    default:
      return defaultSymbol;
  }
};

export const getCurrencyName = (value) => {
  switch (value) {
    case 1:
      return "Soles";
    case 2:
      return "Dólares";
    case 3:
      return "Euros";
    default:
      return "Soles";
  }
};

export default function CardSorteo({ item }) {
  const {
    anforaId,
    sorteoWinnerId: winnerId,
    id: sorteoId,
    premioTipo,
    kind,
    couponTypeName,
    amount,
    couponTypeId,
  } = item;
  const { currencyConfig: contextCurrencyConfig } = useContext(SiteContext);
  const currencyConfig = contextCurrencyConfig || getCurrencyConfig();
  const hotSeatName = GetHotSeatName();

  const navigate = useNavigate();

  const verificarVidaSorteo = (winnerId, sorteoId, kind, couponTypeId) => {
    localStorage.setItem("anforaId", anforaId);
    if (kind === "TORNEO") {
      navigate(`/torneo-view-rank/${sorteoId}?couponTypeId=${couponTypeId}`);
    } else {
      navigate("/idle/" + sorteoId);
    }
  };

  function getTypeRaffle() {
    switch (kind) {
      case "MANUAL":
        return "MANUAL";
      case "VIRTUAL":
        return "VIRTUAL";
      case "FLASH":
        return "FLASH";
      case "HOT_SEAT":
        return "HOT SEAT";
      case "TORNEO":
        return "TORNEO";
      default:
        return "Manual";
    }
  }

  function getFormattedHour(datetime) {
    return DateTime.fromISO(datetime).toFormat("hh:mm a");
  }

  return (
    <RaffleRow
      type="button"
      data-testid="raffle-row"
      onClick={() =>
        verificarVidaSorteo(winnerId, sorteoId, kind, couponTypeId)
      }
    >
      <TimeCell>{getFormattedHour(item.fechaHora)}</TimeCell>
      <NameWithModel>
        <RaffleTypeModel kind={kind === "HOT_SEAT" ? "machine" : kind === "TORNEO" ? "trophy" : "ticket"} />
        <NameDetails>
        <RaffleType>{getTypeRaffle()}</RaffleType>
        <span>{kind === "HOT_SEAT" ? hotSeatName : couponTypeName}</span>
        </NameDetails>
      </NameWithModel>
      <PrizeCell>
        {premioTipo === "soles" || premioTipo === "CASH"
          ? `${getCurrencySymbol(item.currencyId, currencyConfig.symbol)} ${amount}`
          : `${amount} ${item.description || ""}`}
      </PrizeCell>
      <StatusCell>
        <StatusIcon role="img" aria-label={winnerId ? "Sorteado" : "Por sortear"}
          title={winnerId ? "Sorteado" : "Por sortear"}>
          {winnerId ? <LuCheck aria-hidden="true" /> : <LuClock aria-hidden="true" />}
        </StatusIcon>
        <StatusLabel>{winnerId ? "Sorteado" : "Por sortear"}</StatusLabel>
      </StatusCell>
    </RaffleRow>
  );
}
